import util from "@/util/index";

/*
 * 接口地址
 *  http://ecar.meisenpay.com:8899/ecar/swagger-ui.html#/
 */
const BASE_URL = "/api";

/*登录*/
export const login = ({ user, password }) => util.post(BASE_URL + "/login", { user, password });

/*获取平台列表*/
export const getplatformList = ({}) => util.post(BASE_URL + "/platform/list", {});

/*获取所有区域*/
export const getArea = ({}) => util.post(BASE_URL + "/Station/AreaList", {});

/*获取站点信息*/
export const getSite = ({
        area_code,
        cec_id,
        cec_station_id,
        city_code,
        from,
        id,
        limit,
        name,
        status,
    }) =>
    util.post(BASE_URL + "/Station/list", {
        area_code,
        cec_id,
        cec_station_id,
        city_code,
        from,
        id,
        limit,
        name,
        status,
    });

/*添加站点*/
export const addSite = ({
        stationInfo: {
            address,
            area_code,
            cec_id,
            cec_station_id,
            city_code,
            id,
            info,
            lat,
            lng,
            name,
            pic,
            price,
            status,
            tag,
            operator_id,
			platform_id
        },
    }) =>
    util.post(BASE_URL + "/Station/Add", {
        stationInfo: {
            address,
            area_code,
            cec_id,
            cec_station_id,
            city_code,
            id,
            info,
            lat,
            lng,
            name,
            pic,
            price,
            status,
            tag,
            operator_id,
			platform_id
        },
    });

/*获取充电枪信息*/
export const getConnector = ({ from, limit, station_id }) =>
    util.post(BASE_URL + "/Connector/list", { from, limit, station_id });

/*获取充电枪状态*/
export const getConnectorStatus = ({ ConnectorIDs }) =>
    util.post(BASE_URL + "/Connector/status", { ConnectorIDs });

/*获取互联互通信息*/
export const getConnact = ({}) => util.post(BASE_URL + "/CEC/list", {});

/*添加互联互通*/
export const addConnact = ({
        cecInfo: {
            data_secret,
            data_secret_iv,
            id,
            my_data_secret,
            my_data_secret_iv,
            my_operator_id,
            my_operator_secret,
            my_sig_secret,
            name,
            operator_id,
            operator_secret,
            sig_secret,
            station_ids,
            url,
			platform_id
        },
    }) =>
    util.post(BASE_URL + "/CEC/add", {
        cecInfo: {
            data_secret,
            data_secret_iv,
            id,
            my_data_secret,
            my_data_secret_iv,
            my_operator_id,
            my_operator_secret,
            my_sig_secret,
            name,
            operator_id,
            operator_secret,
            sig_secret,
            station_ids,
            url,
			platform_id
        },
    });

/*获取充电桩信息*/
export const getEquipment = ({ station_id }) =>
    util.post(BASE_URL + "/Equipment/list", { station_id });

/*查询订单*/
export const getOrder = ({
        cec_id,
        connector_id,
        end_time,
        from,
        limit,
        no,
        start_time,
        station_id,
        tel,
        tk_user_id,
        status,
		platform_id
    }) =>
    util.post(BASE_URL + "/Order/query", {
        cec_id,
        connector_id,
        end_time,
        from,
        limit,
        no,
        start_time,
        station_id,
        tel,
        tk_user_id,
        status,
		platform_id
    });

/*获取订单实时信息*/
export const getOrderDetail = ({ no }) => util.post(BASE_URL + "/Connector/order_detail", { no });

/*获取站点下的所有枪 状态*/
export const getStationDetail = ({ stationId }) =>
    util.post(BASE_URL + "/Station/detail", { stationId });

/*拉取站点*/
export const fetchStation = ({ id }) => util.post(BASE_URL + "/CEC/fetch_station", { id });

/*更新价格*/
export const updatePrice = ({}) => util.post(BASE_URL + "/CEC/update", {});

/*修改站点信息*/
export const updateStation = ({
        stationInfo: {
            address,
            area_code,
            cec_id,
            cec_station_id,
            city_code,
            operator_id,
            id,
            info,
            lat,
            lng,
            name,
            pic,
            price,
            status,
            tag,
			platform_id
        },
    }) =>
    util.post(BASE_URL + "/Station/Edit", {
        stationInfo: {
            address,
            area_code,
            cec_id,
            cec_station_id,
            city_code,
            operator_id,
            id,
            info,
            lat,
            lng,
            name,
            pic,
            price,
            status,
            tag,
			platform_id
        },
    });

/*修改互联互通信息*/
export const updateConnact = ({
        cecInfo: {
            data_secret,
            data_secret_iv,
            id,
            my_data_secret,
            my_data_secret_iv,
            my_operator_id,
            my_operator_secret,
            my_sig_secret,
            name,
            operator_id,
            operator_secret,
            sig_secret,
            station_ids,
            url,
			platform_id
        },
    }) =>
    util.post(BASE_URL + "/CEC/edit", {
        cecInfo: {
            data_secret,
            data_secret_iv,
            id,
            my_data_secret,
            my_data_secret_iv,
            my_operator_id,
            my_operator_secret,
            my_sig_secret,
            name,
            operator_id,
            operator_secret,
            sig_secret,
            station_ids,
            url,
			platform_id
        },
    });

/*上传图片*/
export const uploadImg = postData => util.post(BASE_URL + "/MerchandiseList/uploadCover", postData);

/*添加充电桩*/
export const addEquipment = ({
        equipment: { cec_equipment_id, cec_id, name, power, station_id, type },
    }) =>
    util.post(BASE_URL + "/Equipment/add", {
        equipment: { cec_equipment_id, cec_id, name, power, station_id, type },
    });
/* 修改充电桩信息*/
export const updateEquipment = ({
        equipment: { id, cec_equipment_id, cec_id, name, power, station_id, type },
    }) =>
    util.post(BASE_URL + "/Equipment/edit", {
        equipment: { id, cec_equipment_id, cec_id, name, power, station_id, type },
    });
/* 添加充电枪*/
export const addConnector = ({
        connector: {
            cec_id,
            connector_id,
            current,
            equipment_id,
            name,
            power,
            status,
            type,
            updatetime,
            v_lower,
            v_upper,
        },
    }) =>
    util.post(BASE_URL + "/Connector/add", {
        connector: {
            cec_id,
            connector_id,
            current,
            equipment_id,
            name,
            power,
            status,
            type,
            updatetime,
            v_lower,
            v_upper,
        },
    });

/* 修改充电枪*/
export const updateConnector = ({
        connector: {
            id,
            cec_id,
            connector_id,
            current,
            equipment_id,
            name,
            power,
            status,
            type,
            updatetime,
            v_lower,
            v_upper,
        },
    }) =>
    util.post(BASE_URL + "/Connector/edit", {
        connector: {
            id,
            cec_id,
            connector_id,
            current,
            equipment_id,
            name,
            power,
            status,
            type,
            updatetime,
            v_lower,
            v_upper,
        },
    });

/*删除充电桩*/
export const deletePile = ({ id }) =>
    util.post(BASE_URL + "/Equipment/delete", {
        id,
    });

/*删除充电枪*/
export const deleteConnector = ({ id }) =>
    util.post(BASE_URL + "/Connector/delete", {
        id,
    });

/*获取优惠券列表*/
export const getCoupon = ({}) => util.post(BASE_URL + "/Coupon/list_template", {});

/*
 * 添加优惠券
 * type： 0无限制 1一次性
 * valid: 0无效  1有效
 *价格 金额 元
 */

export const addCoupon = ({
        template: { bg, expire, icon, id, info, money, name, price, stations, type, valid, up, platform_id },
    }) =>
    util.post(BASE_URL + "/Coupon/add_template", {
        template: { bg, expire, icon, id, info, money, name, price, stations, type, valid , up , platform_id },
    });

/*修改优惠券*/
export const updateCoupon = ({
        template: { bg, expire, icon, id, info, money, name, price, stations, type, valid , up , platform_id  },
    }) =>
    util.post(BASE_URL + "/Coupon/edit_template", {
        template: { bg, expire, icon, id, info, money, name, price, stations, type, valid , up , platform_id },
    });

/*删除优惠券*/
export const deleteCoupon = ({ id }) => util.post(BASE_URL + "/Coupon/del_template", { id });

/*用户所持有的优惠券列表*/
export const getUserCoupon = ({ from, limit, end_time, start_time, name, mobile, tk_user_id , platform_id }) =>
    util.post(BASE_URL + "/Coupon/list", {
        from,
        limit,
        end_time,
        start_time,
        name,
        mobile,
        tk_user_id,
		platform_id
    });
	
/*删除优惠券*/
export const couponQuerySum = ({}) => util.post(BASE_URL + "/Coupon/query_sum", {});

/*重置充电桩状态*/
export const resetConnector = ({ connector_id }) =>
    util.post(BASE_URL + "/Connector/reset_connector", { connector_id });

/*手动结算订单*/
export const settlementOrder = ({ no }) =>
    util.post(BASE_URL + "/Connector/settlement_order", { no });

/*停止充电*/
export const stopCharge = ({ no }) => util.post(BASE_URL + "/Connector/stop_charge", { no });

/*添加活动*/
export const addActivity = ({
        end_time,
        int_param1,
        int_param2,
        int_param3,
        name,
        type,
        str_param1,
        str_param2,
		platform_id
    }) =>
    util.post(BASE_URL + "/Activities/add", {
        end_time,
        int_param1,
        int_param2,
        int_param3,
        name,
        type,
        str_param1,
        str_param2,
		platform_id
    });

/*获取活动列表*/
export const getActivity = ({ from, limit }) =>
    util.post(BASE_URL + "/Activities/list", {
        from,
        limit,
    });

/*修改活动*/
export const updateActivity = ({
        id,
        end_time,
        int_param1,
        int_param2,
        int_param3,
        name,
        type,
        str_param1,
        str_param2,
		platform_id
    }) =>
    util.post(BASE_URL + "/Activities/edit", {
        id,
        end_time,
        int_param1,
        int_param2,
        int_param3,
        name,
        type,
        str_param1,
        str_param2,
		platform_id
    });

/**
 * 数据报表
 * sum_type 0-天 ；1-月 ；2-站点
 * @returns
 */
export const getOrderSummary = ({ end_time, start_time, sum_type , platform_id }) =>
    util.post(BASE_URL + "/Order/Summary", {
        end_time,
        start_time,
        sum_type,
		platform_id
    });

/**
 * 导出订单
 */
export const exportOrderExcel = ({
        cec_id,
        connector_id,
        end_time,
        // from,
        // limit,
        no,
        start_time,
        station_id,
        tel,
        tk_user_id,
		platform_id
    }) =>
    util.postBlob(BASE_URL + "/Order/export", {
        cec_id,
        connector_id,
        end_time,
        // from,
        // limit,
        no,
        start_time,
        station_id,
        tel,
        tk_user_id,
		platform_id
    });

/**
 * 订单统计
 */
export const getOrderQuerySum = ({
        cec_id,
        connector_id,
        end_time,
        // from,
        // limit,
        no,
        start_time,
        station_id,
        tel,
        tk_user_id,
        status,
		platform_id
    }) =>
    util.post(BASE_URL + "/Order/query_sum", {
        cec_id,
        connector_id,
        end_time,
        // from,
        // limit,
        no,
        start_time,
        station_id,
        tel,
        tk_user_id,
        status,
		platform_id
    });

export const getStationIdList = ({}) => util.post(BASE_URL + "/Station/id_list", {});

export let ICCard = {
    addICCard({ no , platform_id , stations }) {
        return util.post(BASE_URL + "/ICCard/add", { no , platform_id , stations });
    },
    getICCardList({ from, limit , platform_id , no }) {
        return util.post(BASE_URL + "/ICCard/list", { from, limit , platform_id , no });
    },
};

//生成优惠券兑换码
export const generateRedeem = ({ count, template_id }) =>
    util.postBlob(BASE_URL + "/Coupon/generate_redeem", {
        count,
        template_id,
    });
//系统参数
export let systemParams = {
	addSystem({ 
		system_param: {name,info,integer1,integer2,integer3,integer4,integer5,str1,str2,str3,str4,str5,platform_id},
	}) {
		return util.post(BASE_URL + "/system_params/add", { 
			system_param: {name,info,integer1,integer2,integer3,integer4,integer5,str1,str2,str3,str4,str5,platform_id},
		});
	},
	updateSystem({
		system_param: {id,name,info,integer1,integer2,integer3,integer4,integer5,str1,str2,str3,str4,str5,platform_id},
	}) {
		return util.post(BASE_URL + "/system_params/edit", {
			system_param: {id,name,info,integer1,integer2,integer3,integer4,integer5,str1,str2,str3,str4,str5,platform_id},
		});
	},
	getSystemList({from,limit}) {
		 return util.post(BASE_URL + "/system_params/list", { from, limit });
	}
}
